export const AttendanceLogs = {
      "columns": 12,
      "rows": 2,
      "visual": {
        "id": 1,
        "type": "advancedTable",
        "colorTheme": "colorTheme1",
        "title": "Attendance Logs of National and Regional Sales Managers",
        "binding": {
          "data": {
            "columns": [
              {
                "name": 'Code',
                "columnName": 'Code',
                "width": '150px',
                "align": "left",
                "sortable": true
              },              
              {
                "name": 'Designation',
                "columnName": 'Designation',
                "width": '250px',
                "align": "left",
                "sortable": true
              },
              {
                "name": 'Name',
                "columnName": 'Name',
                "width": '200px',
                "align": "left",
                "sortable": true
              },
              {
                "name": 'Start Date',
                "columnName": 'StartDate',
                "width": '150px',
                "align": "left",
                "sortable": true
              },
              {
                "name": 'Start Time',
                "columnName": 'StartTime',
                "width": '150px',
                "align": "left",
                "sortable": true
              },
              {
                "name": 'Start Location',
                "columnName": 'StartLocation',
                "width": '300px',
                "align": "left",
                "sortable": true
              },
              {
                "name": 'End Date',
                "columnName": 'EndDate',
                "width": '150px',
                "align": "left",
                "sortable": true
              },
              {
                "name": 'End Time',
                "columnName": 'EndTime',
                "width": '150px',
                "align": "left",
                "sortable": true
              },
              {
                "name": 'End Location',
                "columnName": 'EndLocation',
                "width": '300px',
                "align": "left",
                "sortable": true
              },
              {
                "name": 'Duration',
                "columnName": 'Duration',
                "width": '150px',
                "align": "center",
                "sortable": true
              }                                         
            ],
            "title": 'AttendanceLogs',
            "endpoint": "N01",
            "parameters": [
              { "key": "FromMonth", "value": "2024" },
              { "key": "FromYear", "value": "1" },
              { "key": "ToMonth", "value": "2024" },
              { "key": "ToYear", "value": "1" }
            ]
          },
          "context": {
            "point": {
              "onClick": {
              }
            }
          }
        }
      }
}
